import { ENDPOINTS } from './endpoints';
import { fetchData } from './network';

export function submitPreQualification(data) {
  const url = new URL(`${process.env.API_URL}${ENDPOINTS.submitPreQualification.path}`);

  return fetchData(url, {
    method: ENDPOINTS.submitPreQualification.method,
    body: JSON.stringify({ data })
  }).then((response) => response.data);
}
